import Configuracao from './Configuracao';

export default Configuracao;